export default "__VITE_ASSET__Bl6$NFpM__"